'use client';

import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { usePathname } from 'next/navigation';
import store from '@/store/smartclass';
import sagaRunner from '@/sagas/runners/smartclass';
import { APP_START } from '@/action-types/app';
import useRedirects from '@/hook/useRedirects';
import useResizeHandler from '@/hook/useResizeHandler';
import { TranslationProvider } from '@/contexts/translation';
import GDPRTooltip from '@/components/common/gdpr-tooltip/GDPRTooltip';
import NoSSR from '@/components/common/no-ssr/NoSSR';
import oldbrowser from './oldbrowser';

import '@/assets/styles/app.scss';

if (typeof window !== 'undefined') {
  sagaRunner();

  store.dispatch({
    type: APP_START,
  });
}

const AppWrapper = (props: {
  children: React.ReactNode;
}) => {
  useRedirects();
  useResizeHandler();

  useEffect(() => {
    oldbrowser();
  }, []);

  const pathname = usePathname();
  // TODO: не отримувати lang напряму з url
  const lang = pathname?.match(/^\/(..)\//)?.[1] ?? 'en';

  return (
    <Provider store={store}>
      {props.children}
      <TranslationProvider lang={lang}>
        <NoSSR>
          <GDPRTooltip />
        </NoSSR>
      </TranslationProvider>
    </Provider>
  );
};

export default AppWrapper;
